import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

export const defaultThemeConfig: ThemeConfig = {
  pdPrimaryColor: '',
  pdSecondaryColor: '',
  pdBackgroundColor: '',
  textColor: '',
  playHeaderColor: '',
  borderColor: '',
  primaryColor: '',
  primaryColorActive: '',
  primaryColorLight: '',
  primaryColorLightDark: '',
  primaryTextOnPrimary: '',
  skyColor: '',
  skyColorActive: '',
  skyColorLight: '',
  bootstrapPrimaryLightDark: '',
  logoUrl: '',
  iconLogoUrl: '',
  name: '',
  portadaImage: '',
  nameByRoute: '',
  coverImageUrl: ''
};


export interface ThemeConfig {
  pdPrimaryColor: string;
  pdSecondaryColor: string;
  pdBackgroundColor: string;
  textColor: string;
  playHeaderColor: string;
  borderColor: string;
  primaryColor: string;
  primaryColorActive: string;
  primaryColorLight: string;
  primaryColorLightDark: string;
  primaryTextOnPrimary: string;
  skyColor: string;
  skyColorActive: string;
  skyColorLight: string;
  bootstrapPrimaryLightDark: string;
  logoUrl: string;         // URL o base64
  iconLogoUrl: string;     // URL o base64
  name: string;
  portadaImage: string; // URL o base64
  nameByRoute: string; // URL o base64
  coverImageUrl: string; // URL o base64
}

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private apiUrl = environment.apiUrl;

  private themeSubject = new BehaviorSubject<ThemeConfig>(defaultThemeConfig);
  theme$ = this.themeSubject.asObservable();

  constructor(private http: HttpClient) { }
  public loadTheme(name?: string): Observable<ThemeConfig> {
    const localKey = 'themeConfig';
    const localData = localStorage.getItem(localKey);

    if (localData) {
      try {
        const parsed: ThemeConfig = JSON.parse(localData);

        if (!name) {
          this.themeSubject.next(parsed);
          return of(parsed);
        }

        if (parsed.nameByRoute.toLowerCase() === name.toLowerCase()) {
          this.themeSubject.next(parsed);
          return of(parsed);
        }

        localStorage.removeItem(localKey);
      } catch (error) {
      }
    }

    return this.http.get<ThemeConfig>(`${this.apiUrl}/lottery/hub/${name}/colors`).pipe(
      tap(theme => {
        localStorage.setItem(localKey, JSON.stringify(theme));
        this.themeSubject.next(theme);
      })
    );
  }

  public applyTheme(theme: any) {
    if (theme.name) {
      document.title = theme.name;
    }

    if (theme.iconLogoUrl) {
      this.updateFavicon(theme.iconLogoUrl)
    }

    Object.keys(theme).forEach(key => {
      document.documentElement.style.setProperty(`--${key}`, theme[key]);
    });
  }

  private updateFavicon(iconUrl?: string): void {
    if (!iconUrl) return;

    let favicon = document.querySelector("link[rel~='icon']") as HTMLLinkElement;

    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }

    favicon.href = iconUrl;
  }

  private clearPreviousTheme(): void {
    localStorage.removeItem('themeConfig');

    const root = document.documentElement;
    const stylesToRemove = Array.from(root.style).filter(styleName => styleName.startsWith('--'));

    stylesToRemove.forEach(styleName => {
      root.style.removeProperty(styleName);
    });
  }

}
